import { render, staticRenderFns } from "./EventData.vue?vue&type=template&id=673c1144&scoped=true"
import script from "./EventData.vue?vue&type=script&lang=js"
export * from "./EventData.vue?vue&type=script&lang=js"
import style0 from "./EventData.vue?vue&type=style&index=0&id=673c1144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c1144",
  null
  
)

export default component.exports